const a = document.createElement('a');

export default function (uri: string) {
  a.href = uri;
  return a.href;
}



// WEBPACK FOOTER //
// ./src/resolveUri.ts